// Made by crown7367 on Discord

(() => {
  const removeLegacyVendorFacets = () => {
    document.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
      const vendor = String(input.value || '').trim().toLowerCase();
      if (vendor !== 'starsuniform' && vendor !== 'uniform warehouse source') return;

      const item = input.closest('.facets__item, .mobile-facets__item, li');
      if (item) item.remove();
    });
  };

  removeLegacyVendorFacets();
  document.addEventListener('DOMContentLoaded', removeLegacyVendorFacets);

  if (document.documentElement) {
    new MutationObserver(removeLegacyVendorFacets).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  const widget = document.querySelector('[data-stars-chat]');
  if (!widget) return;

  const toggle = widget.querySelector('[data-stars-chat-toggle]');
  const form = widget.querySelector('[data-stars-chat-form]');
  const input = widget.querySelector('[data-stars-chat-input]');
  const messages = widget.querySelector('[data-stars-chat-messages]');
  const quickButtons = widget.querySelectorAll('[data-stars-chat-quick]');

  const quoteUrl = '/#bulk-quote';
  const contactPhone = '+1 609 475 5503';
  const contactEmail = 'sfuniforms@gmail.com';
  const contactAddress = '2400 Whitehorse Mercerville Road, New Jersey, USA';
  const shippingPromo = 'Fast shipping support';
  const hiddenProductHandles = new Set(['most-luxurious-bed-sheets-elegant-comfort']);
  const stopWords = new Set(['price', 'cost', 'show', 'need', 'want', 'with', 'for', 'all', 'the', 'how', 'much', 'does', 'what', 'is', 'are', 'and', 'from', 'have']);
  let catalogPromise;
  let catalog = [];

  const money = (value) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(number);
  };

  const clean = (value) =>
    String(value || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const tokenStem = (word) => word.replace(/s$/, '');

  const queryWords = (query) =>
    query
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .map(tokenStem)
      .filter((word) => word.length > 2 && !stopWords.has(word));

  const normalizedText = (value) => queryWords(value).join(' ');

  const priceRange = (variants) => {
    const prices = variants.map((variant) => Number(variant.price)).filter(Number.isFinite);
    if (!prices.length) return 'Price unavailable';

    const min = Math.min(...prices);
    const max = Math.max(...prices);
    return min === max ? money(min) : `${money(min)} - ${money(max)}`;
  };

  const validComparePrice = (variants) => {
    const saleCompares = variants
      .map((variant) => ({
        price: Number(variant.price),
        compare: Number(variant.compare_at_price),
      }))
      .filter((variant) => Number.isFinite(variant.price) && Number.isFinite(variant.compare) && variant.compare > variant.price)
      .map((variant) => variant.compare);

    if (!saleCompares.length) return '';
    return money(Math.max(...saleCompares));
  };

  const normalizeProduct = (product) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const available = variants.some((variant) => variant.available);
    const compare = validComparePrice(variants);
    const options = Array.isArray(product.options) ? product.options : [];
    const optionSummary = options
      .map((option) => {
        const values = Array.isArray(option.values) ? option.values.filter(Boolean).slice(0, 8).join(', ') : '';
        return values ? `${option.name}: ${values}` : '';
      })
      .filter(Boolean)
      .join(' | ');

    return {
      title: product.title,
      handle: product.handle,
      url: `/products/${product.handle}`,
      type: product.product_type || '',
      tags: Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || ''),
      description: clean(product.body_html),
      price: priceRange(variants),
      compare,
      options: optionSummary,
      available,
      searchable: `${product.title} ${product.handle} ${product.product_type || ''} ${Array.isArray(product.tags) ? product.tags.join(' ') : product.tags || ''} ${clean(product.body_html)}`.toLowerCase(),
    };
  };

  const loadCatalog = () => {
    if (catalogPromise) return catalogPromise;

    catalogPromise = fetch('/products.json?limit=250', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Catalog unavailable');
        return response.json();
      })
      .then((data) => {
        catalog = (data.products || []).filter((product) => !hiddenProductHandles.has(product.handle)).map(normalizeProduct);
        return catalog;
      })
      .catch(() => {
        catalog = [];
        return catalog;
      });

    return catalogPromise;
  };

  const addMessage = (text, fromUser = false, actions = []) => {
    const message = document.createElement('div');
    message.className = `stars-chat__message${fromUser ? ' stars-chat__message--user' : ''}`;

    const body = document.createElement('span');
    body.textContent = text;
    message.appendChild(body);

    if (actions.length) {
      const actionList = document.createElement('div');
      actionList.className = 'stars-chat__actions';

      actions.slice(0, 4).forEach((action) => {
        const link = document.createElement('a');
        link.href = action.href;
        link.textContent = action.label;
        actionList.appendChild(link);
      });

      message.appendChild(actionList);
    }

    messages.appendChild(message);
    messages.scrollTop = messages.scrollHeight;
  };

  const summarizeProducts = (products, intro) => {
    if (!products.length) {
      return {
        text: 'I could not find a matching active uniform product. Try another search term or request a bulk quote so Stars Uniform can confirm availability.',
        actions: [
          { label: 'Search uniforms', href: '/search?q=uniform&type=product' },
          { label: 'Request bulk quote', href: quoteUrl },
        ],
      };
    }

    const lines = products.slice(0, 5).map((product) => {
      const saleNote = product.compare ? `, compare-at ${product.compare}` : '';
      const optionNote = product.options ? `, options: ${product.options}` : '';
      const stock = product.available ? 'available' : 'sold out';
      return `${product.title}: ${product.price}${saleNote}${optionNote} (${stock})`;
    });

    return {
      text: `${intro} ${lines.join(' | ')}. Prices come from the current public Shopify catalog. Contact Stars Uniform to confirm bulk availability or urgent timing.`,
      actions: products.slice(0, 4).map((product) => ({ label: product.title, href: product.url })),
    };
  };

  const scoreProducts = (query) => {
    const words = queryWords(query);
    const phrase = words.join(' ');

    return catalog
      .map((product) => {
        let score = 0;
        const title = normalizedText(product.title);
        const handle = normalizedText(product.handle);
        const searchable = normalizedText(product.searchable);

        if (phrase.length && title.includes(phrase)) score += 30;
        if (phrase.length && handle.includes(phrase)) score += 20;

        words.forEach((word) => {
          if (title.split(' ').includes(word)) score += 8;
          if (handle.split(' ').includes(word)) score += 5;
          if (searchable.split(' ').includes(word)) score += 1;
        });
        return { product, score };
      })
      .filter((result) => result.score > 0)
      .sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title));
  };

  const categoryMatches = (text) => {
    if (text.includes('vest') || text.includes('tactical')) return catalog.filter((product) => product.searchable.includes('vest') || product.searchable.includes('tactical'));
    if (text.includes('polo')) return catalog.filter((product) => product.searchable.includes('polo'));
    if (text.includes('button')) return catalog.filter((product) => product.searchable.includes('button'));
    if (text.includes('t-shirt') || text.includes('t shirt') || text.includes('tee')) return catalog.filter((product) => product.searchable.includes('t shirt') || product.searchable.includes('t-shirt'));
    if (text.includes('long sleeve')) return catalog.filter((product) => product.searchable.includes('long sleeve'));
    if (text.includes('coverall') || text.includes('workwear')) return catalog.filter((product) => product.searchable.includes('coverall') || product.searchable.includes('workwear'));
    if (text.includes('security')) return catalog.filter((product) => product.searchable.includes('security'));
    return [];
  };

  const replyFor = async (rawText) => {
    await loadCatalog();
    const text = rawText.toLowerCase();

    if (text.includes('contact') || text.includes('phone') || text.includes('email') || text.includes('support')) {
      return {
        text: `You can contact Stars Uniform at ${contactPhone} or ${contactEmail}. Service center: ${contactAddress}. For quotes, include product type, quantity, sizes, colors, deadline, and logo/customization needs.`,
        actions: [
          { label: 'Request bulk quote', href: quoteUrl },
          { label: 'Email Stars Uniform', href: `mailto:${contactEmail}` },
        ],
      };
    }

    if (text.includes('bulk') || text.includes('quote') || text.includes('company') || text.includes('team') || text.includes('wholesale')) {
      return {
        text: 'For bulk orders, send the product needed, quantity, sizes, colors, deadline, and whether logo customization is needed. Stars Uniform should confirm final pricing and availability before urgent or large orders.',
        actions: [
          { label: 'Open quote form', href: quoteUrl },
          { label: 'Call Stars Uniform', href: `tel:${contactPhone.replace(/\s/g, '')}` },
        ],
      };
    }

    if (text.includes('shipping') || text.includes('return') || text.includes('delivery') || text.includes('warranty')) {
      return {
        text: `${shippingPromo} is listed in the current Stars Uniform store. Shipping, returns, delivery timing, and warranty details can depend on the item and order size. Please contact Stars Uniform for confirmation before placing an urgent, customized, or bulk order.`,
        actions: [
          { label: 'Contact support', href: `mailto:${contactEmail}` },
          { label: 'Request quote', href: quoteUrl },
        ],
      };
    }

    if (text.includes('size') || text.includes('color') || text.includes('option') || text.includes('variant')) {
      const scoredProducts = scoreProducts(text).map((result) => result.product);
      const products = scoredProducts.length ? scoredProducts : catalog.slice(0, 5);
      return summarizeProducts(products, 'Available product options from the current catalog:');
    }

    if (text.includes('all products') || text === 'products' || text.includes('catalog')) {
      return summarizeProducts(catalog, 'Active Stars Uniform catalog:');
    }

    if (text.includes('deal') || text.includes('sale') || text.includes('discount')) {
      const saleProducts = catalog.filter((product) => product.compare);
      return summarizeProducts(saleProducts, 'Current products with valid compare-at pricing:');
    }

    const scoredProducts = scoreProducts(text);
    if (scoredProducts.length && queryWords(text).length > 1) {
      const topScore = scoredProducts[0].score;
      const focusedProducts = scoredProducts
        .filter((result) => result.score >= Math.max(2, topScore - 8))
        .map((result) => result.product);

      return summarizeProducts(focusedProducts, topScore >= 20 ? 'Best match:' : 'Closest matching products:');
    }

    const categoryProducts = categoryMatches(text);
    if (categoryProducts.length) {
      return summarizeProducts(categoryProducts, 'Matching products:');
    }

    if (scoredProducts.length) {
      return summarizeProducts(scoredProducts.map((result) => result.product), 'I found these products:');
    }

    return {
      text: 'I can help with security uniforms, tactical vests, polo shirts, button-up shirts, T-shirts, workwear, pricing, or bulk quotes. If you are unsure, request a quote and Stars Uniform can confirm the best option.',
      actions: [
        { label: 'Shop all products', href: '/collections/all' },
        { label: 'Request bulk quote', href: quoteUrl },
      ],
    };
  };

  const handlePrompt = async (text) => {
    addMessage(text, true);
    input.value = '';

    const thinkingText = catalogPromise ? 'Checking the catalog...' : 'Loading current catalog pricing...';
    const thinking = document.createElement('div');
    thinking.className = 'stars-chat__message stars-chat__message--status';
    thinking.textContent = thinkingText;
    messages.appendChild(thinking);
    messages.scrollTop = messages.scrollHeight;

    const response = await replyFor(text);
    thinking.remove();
    addMessage(response.text, false, response.actions);
  };

  toggle.addEventListener('click', () => {
    const isOpen = widget.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) {
      loadCatalog();
      input.focus();
    }
  });

  quickButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const text = button.dataset.starsChatQuick || button.textContent.trim();
      handlePrompt(text);
    });
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const text = input.value.trim();
    if (!text) return;
    handlePrompt(text);
  });
})();
